import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HelperService } from 'app/helpers/helper.service';
import { PostService } from 'app/helpers/post.service';
import { environment } from 'environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-conform-gender',
  templateUrl: './conform-gender.component.html',
  styleUrls: ['./conform-gender.component.scss'],
  encapsulation: ViewEncapsulation.None,

})
export class ConformGenderComponent implements OnInit {
  booth_id: any;

  form = new FormGroup({
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialog_param: any,
    public matDialogRef: MatDialogRef<ConformGenderComponent>,
    private _activatedRoute: ActivatedRoute,
    private helper: HelperService,
    private postService: PostService,
    private translateService: TranslateService,
    private snackBar: MatSnackBar,
  ) {
    this.booth_id = dialog_param;
    
   }

  ngOnInit(): void {
  }

  submit(){

    var myJson = this.form.value;
    myJson.booth_id = this.booth_id;

    this.postService.post(environment.SPLIT_BOOTH, myJson).subscribe(val => {
      if (val.status == "success") {
            this.translateService
              .get("Your Request Success")
              .subscribe((val) => {
                this.snackBar.open(val, "Close!", {
                  panelClass: "snack-success",
                  duration: 5000,
                });
              });
            this.matDialogRef.close(val);
          }
    })
  }

  no(){
    this.matDialogRef.close();
  }

}
